<template>
  <Checkbox name="confirmed">
    <template #label>
      <template v-if="brandconfig.BRAND == 'homefans'">
        {{ $t("I accept all General Terms and Conditions click") }}
        <a class="text-foreground underline" :href="brandconfig.GENERAL_TERMS_LINK" target="_blank">{{ $t("here") }}</a>
        {{ $t("and") }}
        <a class="text-foreground underline" href="https://homefans.net/terms-conditions/">{{ $t("here") }}</a>
      </template>
      <template v-else
        >{{ $t("I accept the") }}
        <a class="text-foreground underline" :href="brandconfig.GENERAL_TERMS_LINK" target="_blank">{{
          $t("General Terms and Conditions")
        }}</a
        ><Tooltip class="font-medium" info="Required" position="right">*</Tooltip></template
      >
    </template>
  </Checkbox>
</template>
<script setup lang="ts">
import brandconfig from "@/brandconfig";
import { useField } from "vee-validate";
import { Checkbox, Tooltip } from "@xs2event/js-lib/components";
import { ref, watch } from "vue";

const field = useField<boolean>("confirmed");

const confirmed = ref(false);

watch(confirmed, (value) => (field.value.value = value));
</script>
